import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

export interface AiBoqItem {
  section_code?: string;
  section_name?: string;
  item_code: string;
  item_description: string;
  specification?: string;
  unit: string;
  quantity: number;
  material_unit_rate: number;
  labor_unit_rate: number;
  equipment_unit_rate: number;
  other_costs: number;
  unit_rate: number;
  line_total: number;
  material_id?: number | null;
  sequence_order?: number;
  source: string;
  rate_source: string;
  needs_confirm?: boolean;
}

export interface AiBoqSection {
  section_code: string;
  section_name: string;
  description?: string;
  sequence_order?: number;
}

export interface AiBoqPreview {
  project: {
    id: number;
    project_name: string;
    domain?: string;
    sub_domain?: string;
    size?: number;
    fsi?: number;
    road_length?: number;
  };
  source_boq?: { boq_id: number; boq_code: string } | null;
  sections: AiBoqSection[];
  items: AiBoqItem[];
  totals: { subtotal: number; item_count: number };
  rationale: string[];
  ai: { enabled: boolean; reason?: string | null; model?: string | null };
  generated_at: string;
}

@Injectable({ providedIn: 'root' })
export class AiBoqService {
  private baseUrl = `${environment.BASE_URL}ai-boq`;

  constructor(private http: HttpClient) {}

  preview(body: { project_id?: number; boq_id?: number }): Observable<{ status: string; data: AiBoqPreview }> {
    return this.http.post<{ status: string; data: AiBoqPreview }>(`${this.baseUrl}/preview`, body);
  }

  apply(body: {
    project_id: number;
    sections: AiBoqSection[];
    items: AiBoqItem[];
    rationale?: string[];
  }): Observable<{
    status: string;
    message?: string;
    data: { boq_id: number; boq_code: string; boq_name: string; version: number; status: string };
  }> {
    return this.http.post<{
      status: string;
      message?: string;
      data: { boq_id: number; boq_code: string; boq_name: string; version: number; status: string };
    }>(`${this.baseUrl}/apply`, body);
  }
}
